import { defineStore } from "pinia"
import axios from "axios"
import { url } from "../helper"
// import { useDatabase } from "../composables/useDatabase.ts"
import { useSession } from "../composables/useSession.ts"
import { reactive } from "vue"
import router from "../router/router"
import { useRouter } from "vue-router"
import { useRoute } from "vue-router"
import api from "../composables/useApi.ts"
interface User {
	id: number
	user: any
	code: string
	csrf_token: string
	logout_token: string
	mute: boolean
	isLoggedIn: boolean
	appLoaded: boolean
	selected_profile: any
	edit_profile: any
}

export const useUserStore = defineStore("useUserStore", () => {
	const { sessionToken } = useSession()
	const state = reactive<User>({
		id: 0,
		user: null as any,
		csrf_token: "",
		logout_token: "",
		mute: true,
		code: "",
		isLoggedIn: false,
		appLoaded: false,
		selected_profile: {},
		edit_profile: {},
	})

	/**
	 * Reset the user's password using a temporary password.
	 * @param email - The user's email address
	 * @param temp_password - The temporary password
	 * @param new_password - The new password to set
	 */
	const userResetPassword = async (email: string, temp_password: string, new_password) => {
		if (navigator.onLine) {
			await axios
				.post(
					`${url}/user/lost-password-reset?_format=json`,
					{
						name: email,
						temp_pass: temp_password,
						new_pass: new_password,
					},
					{
						withCredentials: true,
						headers: {
							"Content-Type": "application/json", // Required content type
							"X-CSRF-Token": sessionToken.value,
						},
					}
				)
				.then((response) => {
					router.push("/home")
					// loginCall(state.email, new_password)
				})
		}
	}
	/**
	 * Log out the user, clear all user/session state, and redirect to login.
	 */
	const userLogout = async () => {
		state.selected_profile = null
		state.selected_profile = {}
		localStorage.setItem("hasLoaded", false)
		state.appLoaded = false
		state.isLoggedIn = false
		state.user = null
		state.id = 0
		state.csrf_token = ""
		try {
			localStorage.removeItem("user_profile")
		} catch {}
		router.push("/")
	}

	const appHasLoaded = async () => {
		state.appLoaded = true
	}

	const getUserSubscriptionStatus = async (): Promise<boolean> => {
		return await api.get(`${url}/api/user-has-active-subscription`).then((response) => {
			// console.log("subscription status", response.data)
			const timestampSeconds = Math.floor(Date.now() / 1000)
			if (response.data.active === false || response.data.end_date <= timestampSeconds) {
				return false
			}
			return true
		})
	}

	return {
		state,
		// loginCall,
		// jwtGetAuth,
		getUserSubscriptionStatus,
		userResetPassword,
		userLogout,
		appHasLoaded,
	}
})
